// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__2-GZJ","dense":"_type_dense__jekRO"};